import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useSelector, useDispatch } from "react-redux";

function OrderSuccess() {
    const [cart, setCart] = useState([]);
    const [errors, setErrors] = useState(false);
    let cartRaw = useSelector((state) => state.data?.cart);
    useEffect(() => {
        let parsedCart = [];
        if (typeof cartRaw === "string") {
            try {
                parsedCart = JSON.parse(cartRaw);
            } catch (e) {
                console.error("Invalid JSON in cartRaw:", cartRaw);
            }
        }
        setCart(parsedCart);
    }, [cartRaw]);
    return (
        <>
            <div class="successCard">
                <div class="checkmark">
                    <svg viewBox="0 0 52 52">
                        <circle cx="26" cy="26" r="25" fill="none" stroke="#4BB543" />
                        <path d="M16 26l8 8 12-16" />
                    </svg>
                </div>
                <h1>Order Confirmed!</h1>
                <p>Your order has been placed successfully. A confirmation email has been sent to your inbox.</p>
                <a href="/bazaar" class="btn">Go to Homepage</a>
            </div>
        </>
    );
}

export default OrderSuccess;
